export const DEFAULT_FILTER_VALUE = "-1";
export const NOT_SUBMITTED = "not_submitted";
